export default [
     {
        subject: "cars",
        key: "yourVehicles", //this is the parameter found in the url /form/:key 
        pageTitle: "All Cars",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        saveAndExit: true,//whether saving the main info goes back to the main page. this happen when there are another tab to fill then you make this false
        tabTitle: "Vehicle Information", 
        gotApprovalProcess:true,
        tableSettings: {
            route: "vehicles",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                userLink:""
            },
            filterEndpoint: "myVehicles",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        }, 
    },
     

    //------------------------------------------------------------------------------------------

    {
        subject: "cars",
        key: "vehicles", //this is the parameter found in the url /form/:key 
        pageTitle: "All Cars",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        saveAndExit: true,//whether saving the main info goes back to the main page. this happen when there are another tab to fill then you make this false
        tabTitle: "Vehicle Information", 
        gotApprovalProcess:true,
        tableSettings: {
            route: "vehicles",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
            },
            filterEndpoint: "search_vehicles",


            showAddBtn: true,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
]